module.exports = __webpack_public_path__ + "img/ahora12-iso.aebf378c.svg";